/**
 * Plausible event namespace: EXPLORER_*
 * Since Data Portal and Explorer share the same Plausible account, we need to
 * namespace the events to differentiate between them.
 *
 * NOTE: If you modify this file, you must update Plausible custom event page for
 * both staging and prod environments as well.
 * Staging: https://plausible.io/cellxgene.staging.single-cell.czi.technology/settings/goals
 * Prod: https://plausible.io/cellxgene.cziscience.com/settings/goals
 */
export enum EVENTS {
  EXPLORER_DIFF_EXP_BUTTON_CLICKED = "EXPLORER_DIFF_EXP_BUTTON_CLICKED",
  EXPLORER_CATEGORY_EXPAND_BUTTON_CLICKED = "EXPLORER_CATEGORY_EXPAND_BUTTON_CLICKED",
  EXPLORER_CELLSET_BUTTON_CLICKED = "EXPLORER_CELLSET_BUTTON_CLICKED",
  EXPLORER_SUBSET_BUTTON_CLICKED = "EXPLORER_SUBSET_BUTTON_CLICKED",
  EXPLORER_RESET_SUBSET_BUTTON_CLICKED = "EXPLORER_RESET_SUBSET_BUTTON_CLICKED",
  EXPLORER_MODE_LASSO_BUTTON_CLICKED = "EXPLORER_MODE_LASSO_BUTTON_CLICKED",
  EXPLORER_MODE_PAN_ZOOM_BUTTON_CLICKED = "EXPLORER_MODE_PAN_ZOOM_BUTTON_CLICKED",
  EXPLORER_SHOW_LABELS = "EXPLORER_SHOW_LABELS",
  EXPLORER_CLIP_CLICKED = "EXPLORER_CLIP_CLICKED",
  EXPLORER_UNDO_BUTTON_CLICKED = "EXPLORER_UNDO_BUTTON_CLICKED",
  EXPLORER_REDO_BUTTON_CLICKED = "EXPLORER_REDO_BUTTON_CLICKED",
  EXPLORER_DOWNLOAD_COMPLETE = "EXPLORER_DOWNLOAD_COMPLETE",
  EXPLORER_EMBEDDING_CLICKED = "EXPLORER_EMBEDDING_CLICKED",
  EXPLORER_EMBEDDING_SELECTED = "EXPLORER_EMBEDDING_SELECTED",
  EXPLORER_FLOATING_BUTTON_CLICKED = "EXPLORER_FLOATING_BUTTON_CLICKED",
  EXPLORER_COLORBY_CATEGORIES_BUTTON_CLICKED = "EXPLORER_COLORBY_CATEGORIES_BUTTON_CLICKED",
  EXPLORER_COLORBY_HISTOGRAM_CONTINUOUS_BUTTON_CLICKED = "EXPLORER_COLORBY_HISTOGRAM_CONTINUOUS_BUTTON_CLICKED",
  EXPLORER_COLORBY_GENE = "EXPLORER_COLORBY_GENE",
  EXPLORER_ADD_GENE = "EXPLORER_ADD_GENE",
  EXPLORER_GENE_SET_VIEW_DISTRIBUTION = "EXPLORER_GENE_SET_VIEW_DISTRIBUTION",
  EXPLORER_CG_MARKER_GENE_SETS_HEADING_EXPANDED = "EXPLORER_CG_MARKER_GENE_SETS_HEADING_EXPANDED",
  EXPLORER_COLORBY_CG_MARKER_GENE_SET_CLICKED = "EXPLORER_COLORBY_CG_MARKER_GENE_SET_CLICKED",
  EXPLORER_GENESET_HEADING_EXPAND_BUTTON_CLICKED = "EXPLORER_GENESET_HEADING_EXPAND_BUTTON_CLICKED",
  EXPLORER_HANDLE_ADD_NEW_GENE_TO_GENESET_BUTTON_CLICKED = "EXPLORER_HANDLE_ADD_NEW_GENE_TO_GENESET_BUTTON_CLICKED",
  EXPLORER_SEE_ACTIONS_BUTTON_CLICKED = "EXPLORER_SEE_ACTIONS_BUTTON_CLICKED",
  EXPLORER_COLORBY_GENE_SET = "EXPLORER_COLORBY_GENE_SET",
  EXPLORER_MENU_BUTTON_CLICKED = "EXPLORER_MENU_BUTTON_CLICKED",
  EXPLORER_OPEN_CREATE_GENESET_DIALOG_BUTTON_CLICKED = "EXPLORER_OPEN_CREATE_GENESET_DIALOG_BUTTON_CLICKED",
  EXPLORER_ADD_GENE_SET = "EXPLORER_ADD_GENE_SET",
  EXPLORER_SUBMIT_GENE_BUTTON_CLICKED = "EXPLORER_SUBMIT_GENE_BUTTON_CLICKED",
  EXPLORER_DELETE_FROM_GENESET_BUTTON_CLICKED = "EXPLORER_DELETE_FROM_GENESET_BUTTON_CLICKED",
  EXPLORER_PLOT_X_BUTTON_CLICKED = "EXPLORER_PLOT_X_BUTTON_CLICKED",
  EXPLORER_PLOT_Y_BUTTON_CLICKED = "EXPLORER_PLOT_Y_BUTTON_CLICKED",
  EXPLORER_GENE_VIEW_DISTRIBUTION = "EXPLORER_GENE_VIEW_DISTRIBUTION",
  EXPLORER_CATEGORY_SELECT_BUTTON_CLICKED = "EXPLORER_CATEGORY_SELECT_BUTTON_CLICKED",
  EXPLORER_CATEGORICAL_VALUE_SELECT_BUTTON_CLICKED = "EXPLORER_CATEGORICAL_VALUE_SELECT_BUTTON_CLICKED",
  EXPLORER_GENE_DISPLAY_PLOT = "EXPLORER_GENE_DISPLAY_PLOT",
  EXPLORER_GENE_HISTOGRAM_HIGHLIGHT = "EXPLORER_GENE_HISTOGRAM_HIGHLIGHT",
  EXPLORER_SELECT_HISTOGRAM = "EXPLORER_SELECT_HISTOGRAM",
  EXPLORER_GENE_INFO_BUTTON_CLICKED = "EXPLORER_GENE_INFO_BUTTON_CLICKED",
  EXPLORER_CELLTYPE_INFO_BUTTON_CLICKED = "EXPLORER_CELLTYPE_INFO_BUTTON_CLICKED",
  EXPLORER_VIEW_GENE_INFO = "EXPLORER_VIEW_GENE_INFO",
  EXPLORER_IMAGE_SELECT = "EXPLORER_IMAGE_SELECT",
  EXPLORER_IMAGE_DESELECT = "EXPLORER_IMAGE_DESELECT",
  EXPLORER_RE_CENTER_EMBEDDING = "EXPLORER_RE_CENTER_EMBEDDING",
  EXPLORER_ZOOMED = "EXPLORER_ZOOMED",
  EXPLORER_PANNED = "EXPLORER_PANNED",
  EXPLORER_SBS_SELECTED = "EXPLORER_SBS_SELECTED",
  EXPLORER_SBS_SWAPPED = "EXPLORER_SBS_SWAPPED",
  EXPLORER_SBS_SIDE_WINDOW_EMBEDDING_CLICKED = "EXPLORER_SBS_SIDE_WINDOW_EMBEDDING_CLICKED",
  EXPLORER_SBS_SIDE_WINDOW_EMBEDDING_SELECTED = "EXPLORER_SBS_SIDE_WINDOW_EMBEDDING_SELECTED",
  EXPLORER_COLORBY_CATEGORY_EXPAND = "EXPLORER_COLORBY_CATEGORY_EXPAND",
  EXPLORER_COLORBY_CATEGORY_HIGHLIGHT_HISTOGRAM = "EXPLORER_COLORBY_CATEGORY_HIGHLIGHT_HISTOGRAM",
  EXPLORER_COLORBY_CATEGORY_CHANGE_EMBEDDING = "EXPLORER_COLORBY_CATEGORY_CHANGE_EMBEDDING",
  EXPLORER_COLORBY_HISTOGRAM_EXPAND_CATEGORY = "EXPLORER_COLORBY_HISTOGRAM_EXPAND_CATEGORY",
  EXPLORER_COLORBY_HISTOGRAM_HIGHLIGHT_HISTOGRAM = "EXPLORER_COLORBY_HISTOGRAM_HIGHLIGHT_HISTOGRAM",
  EXPLORER_COLORBY_HISTOGRAM_CHANGE_EMBEDDING = "EXPLORER_COLORBY_HISTOGRAM_CHANGE_EMBEDDING",
  EXPLORER_LASSO = "EXPLORER_LASSO",
  EXPLORER_LASSO_CHANGE_EMBEDDING = "EXPLORER_LASSO_CHANGE_EMBEDDING",
  EXPLORER_GENE_SET_HISTOGRAM_HIGHLIGHT = "EXPLORER_GENE_SET_HISTOGRAM_HIGHLIGHT",
  EXPLORER_CLIP_SELECTED = "EXPLORER_CLIP_SELECTED",

  WMG_CLICK_NAV = "WMG_CLICK_NAV",
  COLLECTIONS_CLICK_NAV = "COLLECTIONS_CLICK_NAV",
  CENSUS_DOCUMENTATION_CLICK_NAV = "CENSUS_DOCUMENTATION_CLICK_NAV",
  CENSUS_DIRECTORY_CLICK_NAV = "CENSUS_DIRECTORY_CLICK_NAV",
  DATASETS_CLICK_NAV = "DATASETS_CLICK_NAV",
  DOCUMENTATION_CLICK_NAV = "DOCUMENTATION_CLICK_NAV",
  CELL_GUIDE_CLICK_NAV = "CELL_GUIDE_CLICK_NAV",
  DE_CLICK_NAV = "DE_CLICK_NAV",

  NEWSLETTER_SIGNUP_SUCCESS = "NEWSLETTER_SIGNUP_SUCCESS",
  NEWSLETTER_SIGNUP_FAILURE = "NEWSLETTER_SIGNUP_FAILURE",
  NEWSLETTER_OPEN_MODAL_CLICKED = "NEWSLETTER_OPEN_MODAL_CLICKED",
  NEWSLETTER_EMAIL_SUBMITTED = "NEWSLETTER_EMAIL_SUBMITTED",
  NEWSLETTER_SUBSCRIBE_BUTTON_AVAILABLE = "NEWSLETTER_SUBSCRIBE_BUTTON_AVAILABLE",
}
